import React from "react";
import { connect } from "react-redux";
import {createStructuredSelector} from 'reselect'

import  {selectDirectorySections} from '../../redux/directory/directory.selectors'

import "./directory.styles.scss";
import MenuItem from "../menu-item/menu-item.component";

const Directory = ({sections}) => (
  <div className="directory-menu">
    {/* spread operator */}
    {sections.map(({ id, ...sectionprops }) => (
      // console.log(...sectionprops)
      <MenuItem key={id} {...sectionprops} />
    ))}
  </div>
);
const mapStateToProps= createStructuredSelector({
  sections:selectDirectorySections
})

export default connect(mapStateToProps)(Directory);
